<template>
  <div class="query-status-list">
    <table>
      <thead>
        <th>{{ $t('summary.query.vendors') }}</th>
        <th>{{ $t('summary.query.name') }}</th>
        <th>{{ $t('summary.query.closeDate') }}</th>
        <th>{{ $t('summary.query.status') }}</th>
      </thead>
      <tbody>
        <tr
          v-for="(bidQuery, index) in queries"
          :key="index"
        >
          <td>{{ bidQuery.name }}</td>
          <td>
            {{ bidQuery.order }}
          </td>
          <td>
            {{ bidQuery.closingDate }}
          </td>
          <td :class="statusClass(bidQuery.status)">
            {{ bidQuery.status }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import dateUtil from '@/utils/dateUtil'
import { mapGetters } from 'vuex'
import lodash from 'lodash'
import { queryStatus, queryStatusMap } from '@/utils/locale'

export default {
  name: 'queryStatus',
  methods: {
    statusClass (status) {
      return status ? status.toLowerCase() : 'status'
    },

    formatDate (date) {
      return date ? dateUtil.formatDate(date, 'DD MMM YY, HH:mm') : '-'
    },

    parseLastQuery (query = {}) {
      return {
        order: `${this.$i18n.t('summary.query.name')} ${query.order}`,
        closingDate: this.formatDate(query.closingDate),
        status: query.status === queryStatus.NO_RESPONSE ? queryStatusMap.NO_RESPONSE : query.status,
      }
    },
    getLastQuery (queries = []) {
      const emptyValue = '-'
      let lastQuery = {
        order: emptyValue,
        closingDate: emptyValue,
        status: emptyValue,
      }
      if (queries.length > 0) {
        const sortedQueries = lodash.orderBy(queries, 'order').reverse()
        lastQuery = this.parseLastQuery(sortedQueries[0])
      }
      return lastQuery
    },
  },

  computed: {
    ...mapGetters('tenders', ['currentTender']),
    bids () {
      return this.currentTender && this.currentTender.bids
    },
    queries () {
      if (!this.bids || this.bids.length === 0) return []
      let queries = []
      this.bids.reduce((partial, bid) => {
        const name = deep(bid, 'company.name') || bid.name
        if (bid.queries && bid.queries.length > 0) {
          let lastQuery = this.getLastQuery(bid.queries)
          lastQuery.name = name
          partial.push(lastQuery)
        }
        return partial
      }, queries)
      return queries
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~styles/common';

</style>
